var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadImageAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9683 26C18.3939 26 20.3478 23.9594 20.3478 21.4263V7.52909V7.49391C20.3478 7.45873 20.3478 7.38836 20.3478 7.35318V7.318C20.3478 7.24763 20.3141 7.21245 20.2804 7.14208C20.2804 7.1069 20.2804 7.1069 20.2468 7.07172C20.2131 7.03654 20.2131 7.00135 20.1794 6.96617C20.1794 6.93099 20.1457 6.93099 20.1457 6.8958C20.112 6.86062 20.112 6.82544 20.0783 6.79026L20.0446 6.75507L13.5091 0.316644C13.4754 0.281461 13.4417 0.246279 13.3743 0.211096C13.3743 0.211096 13.3406 0.211096 13.3406 0.175913C13.3069 0.140731 13.2733 0.140731 13.2059 0.105548C13.1722 0.105548 13.1722 0.105548 13.1385 0.0703653C13.1048 0.0703653 13.0374 0.0351828 13.0037 0.0351828H12.9701C12.9027 0.0351828 12.8353 0 12.8016 0H4.3795C1.95393 0 0 2.0406 0 4.57375V21.3911C0 23.9242 1.95393 25.9648 4.3795 25.9648H15.9683V26ZM13.8123 3.51827L16.7768 6.43843H13.8123V3.51827ZM2.02131 21.4263V4.60893C2.02131 3.23681 3.06565 2.14614 4.3795 2.14614H11.791V7.52909C11.791 8.1272 12.2289 8.58457 12.8016 8.58457H18.3265V21.4263C18.3265 22.7984 17.2822 23.889 15.9683 23.889H4.3795C3.06565 23.889 2.02131 22.7984 2.02131 21.4263Z",
    fill: "#DF6574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.20597 15.2633H10.7646C11.3373 15.2633 11.7752 14.8059 11.7752 14.2078C11.7752 13.6097 11.3373 13.1523 10.7646 13.1523H5.20597C4.63326 13.1523 4.19531 13.6097 4.19531 14.2078C4.19531 14.8059 4.66695 15.2633 5.20597 15.2633Z",
    fill: "#DF6574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.20597 20.2281H15.1441C15.7168 20.2281 16.1547 19.7708 16.1547 19.1727C16.1547 18.5746 15.7168 18.1172 15.1441 18.1172H5.20597C4.63326 18.1172 4.19531 18.5746 4.19531 19.1727C4.19531 19.7708 4.66695 20.2281 5.20597 20.2281Z",
    fill: "#DF6574"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImageAlert);
export default __webpack_public_path__ + "static/media/downloadImageAlert.ad1b573e99786b1bf5a34b366a078cbd.svg";
export { ForwardRef as ReactComponent };